/* eslint-disable react/prop-types */
import React, { memo, useMemo } from 'react';

import { Button, CircularProgress } from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

function ButtonUI({ loading, children, positionIcon, ...props }) {
  const iconSize = useMemo(() => {
    if (!isEmpty(props) && !!props.size) {
      if (props.size === 'large') return '2rem';
      return '2.5rem';
    }

    return '1.5rem';
  }, [props]);

  return (
    <Button
      type="button"
      {...props}
      startIcon={
        positionIcon === 'start' &&
        loading && <CircularProgress size={iconSize} color="inherit" />
      }
      endIcon={
        positionIcon === 'end' &&
        loading && <CircularProgress size={iconSize} color="inherit" />
      }
    >
      {children}
    </Button>
  );
}

ButtonUI.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.element.isRequired,
  positionIcon: PropTypes.oneOf(['start', 'end']),
};

ButtonUI.defaultProps = {
  loading: false,
  positionIcon: 'start',
};

export default memo(ButtonUI);
